import request from '@/utils/request'

export const apiGetDeptTree = (params) => {
  return request({
    url: '/hhxc-admin/api/v1/dept/table',
    method: 'get',
    params,
  })
}
export const apiGetDeparmentList = (params) => {
  return request({
    url: '/hhxc-admin/api/v1/dept',
    method: 'get',
    params,
  })
}
